var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-button',{on:{"click":function($event){_vm.modalShow = !_vm.modalShow}}},[_vm._v("Open Modal")]),_vm._v(" "),_c('b-modal',{model:{value:(_vm.modalShow),callback:function ($$v) {_vm.modalShow=$$v},expression:"modalShow"}},[_vm._v("Hello From Modal!")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }